"use strict";

/**
 * @module Timer
 */

/**
 * Default timeout
 */
var defaultTimeoutLength = 15000;

/**
 * Timer
 */
function Timer() {
  var timeout;

  /**
   * Start the timer to report events
   * If a timeoutLength is provided that value is used otherwise it uses the
   * defaultTimeoutLength
   * @function start
   * @param {integer} onTimeout
   * @param {integer} Optional timeoutLength
   */
  this.start = function (onTimeout, timeoutLength) {
    this.clear();
    timeout = setTimeout(onTimeout, timeoutLength || defaultTimeoutLength);
  };

  /**
   * Clear the timer
   * @function clear
   */
  this.clear = function () {
    if (timeout) {
      clearTimeout(timeout);
      timeout = undefined;
    }
  };
}

module.exports = Timer;
//# sourceMappingURL=Timer.js.map